var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95223 14.6062C4.71966 14.8474 4.42469 15.0151 4.10225 15.0894L0.860311 15.8209C0.509758 15.9 0.192723 15.5945 0.258781 15.2413L0.895871 11.8345C0.965181 11.5025 1.12562 11.1979 1.35818 10.9567L11.6166 0.52631C12.2888 -0.170779 13.3837 -0.176089 14.0623 0.514452L15.1991 1.66326C15.8776 2.3538 15.8828 3.4787 15.2106 4.17579L4.95223 14.6062ZM14.3517 2.16988C14.7588 2.58421 14.7619 3.25915 14.3586 3.6774L13.7426 4.31619C13.6888 4.37196 13.6012 4.37239 13.547 4.31714L11.4947 2.23666C11.4404 2.18142 11.44 2.09143 11.4938 2.03566L12.1097 1.39686C12.513 0.978612 13.17 0.975427 13.5772 1.38975L14.3517 2.16988ZM10.6327 2.92857C10.6865 2.8728 10.7741 2.87238 10.8284 2.92762L12.8807 5.0081C12.935 5.06335 12.9354 5.15334 12.8816 5.20911L4.18967 14.015C4.14316 14.0633 4.08417 14.0968 4.01968 14.1117L1.68136 14.5662C1.58038 14.5858 1.49006 14.5003 1.50416 14.3984L1.84836 11.91C1.86222 11.8437 1.89431 11.7827 1.94082 11.7345L10.6327 2.92857Z",
    fill: "#C2C2C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.96c626534d37cff4d18ed4a3d5837fa4.svg";
export { ForwardRef as ReactComponent };